import { render, staticRenderFns } from "./AmbassadorList.vue?vue&type=template&id=73c934ae&"
import script from "./AmbassadorList.vue?vue&type=script&lang=js&"
export * from "./AmbassadorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports